<div class="new-article">
  @for (instruction of instructions; track instruction; let i = $index) {
    <ut-alert
      [type]="instruction.type"
      [dismissible]="true"
      (close)="closeAlert(i)">
      <div class="container-fluid instruction-message" [innerHTML]="instruction.message"></div>
    </ut-alert>
  }

  <div class="container-fluid block">
    @if (!isPublished) {
      <div>
        <p class="autosave-status">
          <span
            role="button"
            tabindex="0"
            class="clickable"
            [attr.aria-label]="autosaveToggleTooltip"
            [attr.title]="autosaveToggleTooltip"
            (click)="toggleAutosave()"
            (keydown.enter)="toggleAutosave()"
            (keydown.space)="toggleAutosave()">
            @if (autosaveStatus === 'success') {
              <small class="text-success">
                <span class="icon-check"></span> Auto save completed
              </small>
            }
            @if (autosaveStatus === 'error') {
              <small class="text-warning">
                <span class="icon-cancel"></span> {{autosaveError}}
              </small>
            }
            @if (autosaveStatus === 'disabled') {
              <small>
                Auto saving disabled
              </small>
            }
            @if (!autosaveStatus && autosaveStatus !== 'disabled') {
              <small>
                Auto saving enabled
              </small>
            }
          </span>
        </p>
      </div>
    }

    <h1>{{article.id ? 'Edit' : 'New'}} Article</h1>

    <div class="input-row-invisible" [ngClass]="titleError">
      <label>Article Title</label><span> *Required</span>
      <input
        [(ngModel)]="article.title"
        (ngModelChange)="onTitleChange()"
        placeholder="Article Title"
        type="text"
        aria-required="true"
        aria-label="Article Title" />
    </div>

    <div class="form-group input-row-invisible" [ngClass]="contentError">
      <label for="article-uteditor">Article Text</label><span> *Required</span>
      <ut-editor
        [id]="'article-uteditor'"
        [value]="article.content"
        (valueChange)="onContentChange($event)"
        [config]="'full'"
        text-area-label="Write your article here"
        text-required="true">
      </ut-editor>
    </div>

    <ut-slug-input
      [urlPre]="articlesUrlPre"
      [toSlug]="article.title"
      [theSlug]="article.slug"
      [hasError]="slugError"
      (slugChange)="onSlugChange($event)">
    </ut-slug-input>

    <div class="editor-footer">
      <div class="editor-footer-content">
        <div class="editor-footer-content-item">
          <ut-tag-selector
            [availableTags]="preselectedTags"
            [selectedTags]="selectedTags"
            (selectedTagsChange)="onTagsChange($event)"
            [maxTags]="2"
            placeholder="Add up to 2 tags">
          </ut-tag-selector>
        </div>

        @if (!isPublished) {
          <div class="editor-footer-buttons">
            <a
              role="button"
              tabindex="0"
              class="btn btn-save editor-footer-action-btn"
              [class.saved]="saveBtnSaved"
              (click)="action('save')"
              (keydown.enter)="action('save')"
              (keydown.space)="action('save')">
            </a>
            <div class="submit-delete-container">
              @if (!isAdmin) {
                <a
                  role="button"
                  tabindex="0"
                  class="btn btn-blue editor-footer-action-btn"
                  (click)="action('review')"
                  (keydown.enter)="action('review')"
                  (keydown.space)="action('review')">
                  Submit for Review
                </a>
              }
              @if (isAdmin) {
                <a
                  role="button"
                  tabindex="0"
                  class="btn btn-blue editor-footer-action-btn"
                  (click)="action('publish')"
                  (keydown.enter)="action('publish')"
                  (keydown.space)="action('publish')">
                  Publish
                </a>
              }
              @if (showDeleteBtn) {
                <ut-delete-btn
                  (delete)="onDelete()">
                </ut-delete-btn>
              }
            </div>
          </div>
        }

        @if (isPublished) {
          <div class="editor-footer-buttons">
            <a
              role="button"
              tabindex="0"
              class="btn btn-blue editor-footer-action-btn"
              (click)="action('save')"
              (keydown.enter)="action('save')"
              (keydown.space)="action('save')">
              Save & Publish
            </a>
            @if (showDeleteBtn) {
              <ut-delete-btn
                (delete)="onDelete()">
              </ut-delete-btn>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
